module.exports = "/images/frau-4.jpg?fbe5762c8384981fb186cd455b868ddf";